'use strict';

import Device from './Device';

class Installation {
    constructor(installation) {
        this.outService = false;
        this.devices = installation ? installation.t.map((x) => new Device(this, x)) : [];
        let device = this.devices.sort((x) => (x.isOn() ? -1 : 1))[0] || new Device(this); //Get first on
        this.status = device.isOn();
        this.heat = ['0', '2', '4'].includes(device.m);
    }

    //#region is
    isOutService() {
        return this.outService;
    }

    isOn() {
        return this.status;
    }

    isModeHeat() {
        return this.heat;
    }
    //#endregion

    //#region get/set
    setOutService(value) {
        return (this.outService = value);
    }

    getDevice(ref) {
        return this.devices.find((x) => x.rf == ref) || new Device(this);
    }

    setModeHeat(heat) {
        this.heat = heat;
    }

    on() {
        this.status = true;
    }

    off() {
        this.status = false;
    }
    //#endregion
}

export default Installation;
